import axios from 'axios';
import { handleError } from '../utils/error';
const API_URL = process.env.COMMAND_BOT_API_URL;
/*
  CREATE
*/
export const postCommandBotService = async ({ token, itemNumber }) => {
    try {
        const response = await axios.post(`${API_URL}/service`, {
            itemNumber: itemNumber
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('postCommandBotService', error);
        return error.response;
    }
};
export const postCommandBotMessage = async ({ token, itemNumber, trigger, message }) => {
    try {
        const response = await axios.post(`${API_URL}/message`, {
            itemNumber: itemNumber,
            trigger: trigger,
            message: message
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('postCommandBotMessage', error);
        return error.response;
    }
};
/*
  READ
*/
export const getCommandBotServices = async ({ itemNumber }) => {
    try {
        const response = await axios.get(`${API_URL}/service/${itemNumber}`);
        return response;
    }
    catch (error) {
        handleError('getCommandBotServices', error);
        return error.response;
    }
};
export const getCommandBotServiceBot = async ({ token }) => {
    try {
        const response = await axios.get(`${API_URL}/bot/`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('getCommandBotServiceBot', error);
        return error.response;
    }
};
/*
  UPDATE
*/
/*
  DELETE
*/
export const deleteCommandBotMessage = async ({ token, id }) => {
    try {
        const response = await axios.delete(`${API_URL}/message/${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response;
    }
    catch (error) {
        handleError('deleteCommandBotMessage', error);
        return error.response;
    }
};
//# sourceMappingURL=CommandBot.js.map